<ng-container *ngIf="initialized">
    <p-chip
            *ngIf="ticketDto"
            class="cursor-pointer"
            [label]="ticketDto.alias + ' (' + ticketDto.id + ')'"
            (click)="openTicketDrawer(ticketId)"
    ></p-chip>
</ng-container>